const Footer = () => {
  return (
    <div>
      <h6 style={{ fontWeight: 800 }}>
        <i>Valid Within 12 Month/s from Transaction Date</i>
      </h6>
      <h6 style={{ fontWeight: 800 }} className="text-center">
        <i>This is a DOF-DDB IDTOMIS generated report</i>
      </h6>
    </div>
  );
};

export default Footer;
